import { userSubject } from './Authentication'
import { CustomError } from './Error'
import { getUrl } from './Microservices'
import { stringifyUrl } from './UrlManipulation'


const callBackend = (microservice, path, { headers, body, params, method }) => {
    const microserviceUrl = getUrl(microservice, userSubject.getUser().provider)
    const url = stringifyUrl(`${microserviceUrl}/${path}`, params)
    return fetch(url, {
        method: method,
        headers: {
            'Content-Type': 'application/json',
            ...headers
        },
        body: body ? JSON.stringify(body) : null,
    })
        .then(async response => {
            if (response.status < 400) {
                return await response.json()
                    // In case there is no json in response
                    .catch(error => {
                        return response
                    })
            } else {
                return response.json()
                    .catch(() => {
                        throw new CustomError({
                            status: response.status,
                            title: response.statusText,
                            detail: `call to "${url}" failed`,
                        })
                    })
                    .then(errorBody => {
                        console.log('errorBody: ', errorBody)
                        throw new CustomError({
                            status: response.status,
                            title: errorBody.message,
                            detail: `call to "${url}" failed`,
                        })
                    })
            }
        })
}

export { callBackend }
